import { root, id } from './content-destinations-schedules';

export const contentDestinationsSchedules = {
  ...root,
  id,
};
